import { gql } from '@apollo/client/core'

export const estimateProductSearchQuery = gql`
  query getEstimateSearchProducts(
    $categoryId: ID
    $minUnitPrice: Int
    $maxUnitPrice: Int
    $printingMethods: [String!]
    $facets: [FacetInput!]
    $offset: Int!
    $limit: Int!
    $sortOrder: SearchSortEnum!
    $industryIds: [ID!]
    $keyword: String
    $userDesignVersionUuid: String
    $editPatterns: [String!]
  ) {
    productSearch(
      categoryId: $categoryId
      industryIds: $industryIds
      maxUnitPrice: $maxUnitPrice
      minUnitPrice: $minUnitPrice
      printingMethods: $printingMethods
      facets: $facets
      offset: $offset
      limit: $limit
      sortOrder: $sortOrder
      keyword: $keyword,
      userDesignVersionUuid: $userDesignVersionUuid,
      editPatterns: $editPatterns
    ) {
      totalItemsCount
    }
  }
`

export const productSearchQuery = gql`
  query searchProducts(
    $categoryId: ID
    $industryIds: [ID!]
    $minUnitPrice: Int
    $maxUnitPrice: Int
    $printingMethods: [String!]
    $facets: [FacetInput!]
    $offset: Int!
    $limit: Int!
    $sortOrder: SearchSortEnum!
    $keyword: String
    $userDesignVersionUuid: String
    $editPatterns: [String!]
  ) {
    productSearch(
      categoryId: $categoryId
      industryIds: $industryIds
      maxUnitPrice: $maxUnitPrice
      minUnitPrice: $minUnitPrice
      printingMethods: $printingMethods
      facets: $facets
      offset: $offset
      limit: $limit
      sortOrder: $sortOrder
      keyword: $keyword
      userDesignVersionUuid: $userDesignVersionUuid,
      editPatterns: $editPatterns
    ) {
      totalItemsCount
      items {
        id
        brand
        displayName
        minProductPrice
        quantityUnit
        skuDetails {
          skuImage
          psi
        }
        url
        description
        gender
        productCardItems {
          productCardDisplayName
          color
        }
        hasFastShipping
      }
      printingMethod {
        full
        single
      }
      editPatterns {
        editPatternName
        editPatternDisplayName
        count
      }
      facets {
        facetKeyName
        facetKeyId
        facetKeyDisplayName
        facetType
        canonicalSetting
        count
        facetKeyDisplayOrder
        facetValues {
          count
          facetValueName
          facetValueId
          facetValueDisplayOrder
          facetValueDisplayName
        }
      }
      categories {
        id
        topSearchCount
        childCategories {
          id
          topSearchCount
          childCategories {
            id
            topSearchCount
          }
        }
      }
      designImage
    }
  }
`
export const getCategoriesByBrandQuery = gql`
  query brandCategories($brandId: ID!) {
    categoriesByBrand(brandId: $brandId) {
      id
      brandChildCategoriesWithProducts (brandId: $brandId) {
        id
        name
        displayName
        url
        iconImage
        iconImageAlt
      }
    }
  }
`

export const subCategoriesQuery = gql`
  query subCategories($name: String!) {
    category(name: $name) {
      subCategories {
        id
        name
        displayName
        url
        iconImage
        iconImageAlt
      }
    }
  }
`
